/**
 * Created by fjywan on 2018/3/13.
 */
import axios from 'axios'
import Vue from 'vue'

export const baseURL = __BASEURL__

const request = axios.create({
  baseURL,
  withCredentials: true
})

request.interceptors.response.use(function (res) {
  if (res.data.retcode === -100) {
    location.href = baseURL + '/api/login/' + '?redirect=' + encodeURI(location.href)
  } else if (res.data.retcode) {
    Vue.prototype.$message.error(res.data.message)
  }
  return res.data
}, function (error) {
  if (error.request && error.request.status === 401) {
    location.href = (baseURL + '/api/login/' + '?redirect=' + encodeURI(location.href))
    return
  }
  return Promise.reject(error)
})

export default request



// WEBPACK FOOTER //
// ./examples/api/request.js